import { Radio, FormControl, FormLabel } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';

export const RadioBoxClear = (props) => {
    const {
        label,
        style,
        options,
        size = "small",
        value,
        setValue
    } = props;


    return (

        <FormControl >
            <FormLabel component="legend" style={{ color: 'rgba(0, 0, 0, 0.6) !important' }}>{label}</FormLabel>
            <FormGroup row={false}>
                {
                    options.map((item, index) => {
                        let keyOption = item.label + "_" + index;
                        return (
                            <FormControlLabel
                                key={keyOption}
                                control={
                                    <Radio
                                        checked={(value + "") === item.value + ""}
                                        onChange={(e) => {
                                            setValue(e.target.value)
                                            if (props.onChange) props.onChange(e.target.value)
                                        }}
                                        size={size}
                                        style={style}
                                    />
                                }
                                value={item.value}
                                label={item.label}
                            />)
                    })
                }
            </FormGroup>
        </FormControl >
    );
};